import { jsx as _jsx } from "react/jsx-runtime";
import { xyIntegral, xyMaxY } from 'ml-spectra-processing';
import { useChartData } from '../../context/ChartContext';
import useSpectrum from '../../hooks/useSpectrum';
import { Integration } from './Integration';
const emptyData = { integrals: {}, info: {}, display: {} };
export default function IntegralsSeries() {
    const { displayerKey, view: { spectra: { activeTab: nucleus }, }, xDomain: [from, to], } = useChartData();
    const integrals = useIntegrals();
    if (!integrals)
        return null;
    return (_jsx("g", { clipPath: `url(#${displayerKey}clip-chart-1d)`, className: "integrals", children: integrals.values.map((integral) => (_jsx(Integration, { nucleus: nucleus, integral: integral, max: integrals.max, from, to }, integral.id))) }));
}
function useIntegrals() {
    const spectrum = useSpectrum(emptyData);
    if (!spectrum.integrals?.values ||
        !spectrum.display.isVisible ||
        spectrum.info?.isFid) {
        return null;
    }
    let max = Number.NEGATIVE_INFINITY;
    const values = [];
    const { data: { x, re }, integrals, } = spectrum;
    for (const integral of integrals?.values || []) {
        const { from, to } = integral;
        const integralData = xyIntegral({ x, y: re }, {
            from,
            to,
            reverse: true,
        });
        values.push({ ...integral, ...integralData });
        const value = xyMaxY(integralData);
        if (value > max)
            max = value;
    }
    return { max, values };
}
